import * as React from "react"

function SvgComponent(props) {
    return (
        <svg
            width={46}
            height={46}
            viewBox="0 0 46 46"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M39.266 6.734C34.923 2.392 29.146 0 23 0 16.854 0 11.077 2.392 6.734 6.734 2.392 11.077 0 16.854 0 23c0 6.146 2.392 11.923 6.734 16.266C11.077 43.608 16.854 46 23 46c6.146 0 11.923-2.392 16.266-6.734C43.608 34.923 46 29.146 46 23c0-6.146-2.392-11.923-6.734-16.266zM23 43.461C11.72 43.46 2.54 34.279 2.54 23 2.54 11.72 11.72 2.54 23 2.54c11.28 0 20.46 9.18 20.46 20.46 0 11.28-9.18 20.46-20.46 20.46z"
                fill="#fff"
            />
            <path
                d="M25.585 15.916a1.266 1.266 0 00-1.794 0l-6.182 6.182a1.266 1.266 0 000 1.794l6.182 6.183c.248.248.57.377.892.377.323 0 .654-.12.893-.377a1.266 1.266 0 000-1.794L20.304 23l5.29-5.29a1.292 1.292 0 00-.009-1.794z"
                fill="#fff"
            />
        </svg>
    )
}

export default SvgComponent
